require('../js/local-site/loans');
require('../js/local-site/loan-calculator');
require('../js/help');